<!-- Copyright (C) nexleader - All Rights Reserved -->
<!-- Unauthorized copying of this file, via any medium is strictly prohibited -->
<!-- Proprietary and confidential -->
<!-- Written for nexleader <myipsat.com>, 2016-2018 -->

<app-nexleader-onboarding-video (boundNext)="boundNext()"></app-nexleader-onboarding-video>
<div class="nexleader-onboarding-button-container">
  <a class="nexleader-contact-button" (click)="openHelpModal()">Need help?</a>
  <a class="nexleader-logout-button" (click)="logout()">Logout</a>
</div>